import WritingCompetition from "./WritingCompetition";

export default WritingCompetition;
